"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var boxes = [
    'physical_disability',
    'physical_health_risk',
    'mental_health_issues',
    'pregnant',
    'low_income',
    'young_person',
    'council_tax',
    'energy_costs',
    'central_heating',
    'payment_meter',
    'frontline_worker',
    'over_65',
];
var EligibilityInput = function () {
    var trans = __2.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(__1.FormControl, { errors: errors.eligibility, label: trans('optiiva::labels.eligibility') },
        react_1.default.createElement("div", { className: "flex flex-col" }, boxes.map(function (key) { return (react_1.default.createElement(__1.Checkbox, { key: "eligibility-" + key, name: "eligibility", label: trans("project:slhh::enum.eligibility." + key), value: key })); }))));
};
exports.default = EligibilityInput;
//# sourceMappingURL=EligibilityInput.js.map